import { useTranslation } from 'react-i18next'
import { Lightbulb } from 'lucide-react'
import type { AuditReport } from '@/lib/api/amazon-listing'

type Improvement = AuditReport['product_improvements'][number]

interface PotentialQuickWinsProps {
  actions: Improvement[]
}

export function PotentialQuickWins({ actions }: PotentialQuickWinsProps) {
  const { t } = useTranslation()
  const r = (key: string) => t(`amazonListing.potentialCheck.${key}`)

  return (
    <div className="potential-check-quickwins rounded-xl border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 overflow-hidden">
      <div className="px-5 py-3 border-b border-neutral-200 dark:border-neutral-700 flex items-center gap-2">
        <Lightbulb className="w-4 h-4 text-amber-500" aria-hidden="true" />
        <h3 className="font-semibold text-sm text-neutral-900 dark:text-white">
          {r('quickWins')}
        </h3>
      </div>
      <ul className="divide-y divide-neutral-100 dark:divide-neutral-700">
        {actions.map((a, i) => (
          <li key={i} className="px-5 py-3 flex gap-3 items-start">
            <span className="flex-shrink-0 w-6 h-6 rounded-md bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 flex items-center justify-center text-xs font-bold">
              {i + 1}
            </span>
            <div className="min-w-0">
              <p className="text-sm font-medium text-neutral-900 dark:text-white">
                {a.title}
              </p>
              {a.current_state && a.target_state && (
                <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">
                  {a.current_state} → {a.target_state}
                </p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
